<template> 
  <div>
    <LoadingSpinner title="Initializing...This takes a while the first time. Then we will load the opportunities progressively." v-if="loadingNextTask" />
    <div v-else>
      <div class="text-center text-bold mt-4"  v-if="linksFound.length== 0">
        <h4 >No tasks availables.</h4>
        <div class="mt-2">
          <button 
            class="btn btn-primary my-0" 
            @click="getNextTaskAgain()"
            :disabled="tryAgain"
            >Try again
          </button>
          <p class="ml-3 pt-2 mt-0 mb-0 pb-0" v-if="tryAgain">Please wait and try again...</p>
        </div>
      </div>
      <div class="text-center text-bold"  v-if="error">
        <h4>{{error}}</h4>
      </div>

      
      <transition name="fade" v-if="!error">

        <div>
          <Opportunity
            v-if="opportunity_id"
            :key="opportunity_id"
            :opportunity_id="Number(opportunity_id)"
            :fromAdminTasks="true"
            :currentTaskFound="currentTaskFound"
            :tasksTotal="tasksTotal"
            :tasksDone="tasksDone"
            :linksFound="linksFound"
            @selectNextTask="nextTask"
          />

        </div>

      </transition>
    </div>
  </div>
</template>

<script>
import Opportunity from "@/components/Opportunities/Opportunity.vue";
import { mapState } from "vuex";
import { opportunitiesService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  name: 'AdminTasks',

  components: {
    Opportunity,
    LoadingSpinner
  },
  props: {
    linkId: String,
    defaultLinks: Array,
    link: Object
  },

  data() {
    return {
      tryAgain: false,
      opportunity_id: null,
      currentTaskFound: null,
      tasksTotal: null,
      tasksDone: null,
      linksFound: [],
      loadingNextTask: false,
      indexTaskSelected: null,
      error:false,
    };
  },
  created() {
    if(!this.linkId){
      this.getNextTask();
    }else{
      this.opportunity_id = this.linkId
      this.currentTaskFound = this.link
      this.linksFound.push(this.link)
    }
  },

  computed:  {
  ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      currentPage: (state) => state.opportunities.currentPage,
      loading: (state) => state.opportunities.loading,
    }),
  },

  methods: {
    nextTask(){
      this.$emit('showNext',this.linksFound)
    },
    getNextTaskAgain(){
      this.tryAgain = true
      
      this.getNextTask()
      
      //Wait to 20 seconds
      setTimeout(() => {
        this.tryAgain = false
      }, 20000)
    },
    getNextTask(add = false){
      this.loadingNextTask = true;
      this.opportunity_id = null;
      
      opportunitiesService.getNextTask()
        .then(({ result, status }) => {

          this.error  = false;



          if(result && status == '200' && result.task.length > 0){
            if(add){
              const currentLinkId = this.linksFound.find( el => el.taskActive).link_id;

              const resultWithoutCurrentLinkId = result.task
                                                    .filter( el => el.link_id != currentLinkId)
                                                    .map( el => ( {...el, taskActive: false} ))

              this.linksFound.push(...resultWithoutCurrentLinkId);

            } else { 
              //Si es la primera vez que se carga las tareas a procesar para este booker en esta vista
              // entonces guardo las 4 taresa a procesar por este booker en linksFound
              
              this.linksFound = result.task

              this.tasksTotal = result.total.total
              this.tasksDone = result.totalDone.total
              this.selectNextTask('ok');

            }
             this.loadingNextTask = false;

          }else{
            this.linksFound = []
            this.loadingNextTask = false;
          }

          if(status !== 200){
            this.error = "We have a temporaly error. Please reload.";
            this.linksFound = []
            this.loadingNextTask = false;
          }
        })
    },



    selectNextTask(start = null){

      this.loadingNextTask = true;
      setTimeout(() => {
        
        //Sino es la primera tarea seleccionada (osea esta dentro del grupo de las 4 marcadas en el backedn para este user booker)
        // y es una tarea a procesar del grupo de las 4 pero es una tarea que no es la primera sino cualquier otra.         
        if(!start) {

          //Filtro linksFound con todas las tareas que hasta el momento no fueron procesadas por el booker
          this.linksFound = this.linksFound.filter( el => !el.taskActive)
        }

        //Marco la proxima tarea que se convierte en activa
        this.currentTaskMarker(this.linksFound);

        const taskSelected = this.linksFound.find( el => el.taskActive )

        //Si existe una tarea seleccionada, entonces guarda la tarea seleccionada en currentTaskFound y
        //con loadingNexTask false, inicia la carga de la tarea a procesar en el frontend.
        if(taskSelected !== undefined){
          this.opportunity_id = parseInt(taskSelected.link_id)
          this.currentTaskFound = taskSelected
          this.loadingNextTask = false;
        }
      }, 500);

    },

    //Siempre maraca la proxima activa a la tarea siguiente dentro del grupo de las que
    //todavia no fueron procesadas
    currentTaskMarker(data){
      this.linksFound = data.map( (el, index) => {
        const taskActive = index === 0 ? true : false
        return {...el, taskActive }
      })
    }
  },
};
</script>

<style scoped>

</style>
